import type { CSSProperties, ReactNode } from 'react'

type PillTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info' | 'brand' | 'coral'
type PillSize = 'sm' | 'md'

const tones: Record<PillTone, { bg: string; fg: string; dotc: string }> = {
  neutral: { bg: 'var(--ink-100)',    fg: 'var(--ink-800)',    dotc: 'var(--ink-500)' },
  success: { bg: 'var(--success-100)', fg: 'var(--success-700)', dotc: 'var(--success)' },
  warning: { bg: 'var(--warning-100)', fg: 'var(--warning-700)', dotc: 'var(--warning)' },
  danger:  { bg: 'var(--danger-100)',  fg: 'var(--danger-700)',  dotc: 'var(--danger)' },
  info:    { bg: 'var(--info-100)',    fg: 'var(--info-700)',    dotc: 'var(--info)' },
  brand:   { bg: 'var(--brand-100)', fg: 'var(--brand-700)', dotc: 'var(--brand-500)' },
  coral:   { bg: 'var(--accent-100)',fg: 'var(--accent-600)',dotc: 'var(--accent-500)' },
}

interface PillProps {
  tone?: PillTone
  size?: PillSize
  dot?: boolean
  style?: CSSProperties
  children: ReactNode
}

export function Pill({ tone = 'neutral', size = 'md', dot = false, style, children }: PillProps) {
  const t = tones[tone]
  const sz: CSSProperties = size === 'sm'
    ? { fontSize: 11, padding: '2px 8px' }
    : { fontSize: 12, padding: '3px 10px' }

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      borderRadius: 999,
      fontWeight: 600,
      background: t.bg,
      color: t.fg,
      ...sz,
      ...style,
    }}>
      {dot && (
        <span style={{ width: 6, height: 6, borderRadius: '50%', background: t.dotc, flexShrink: 0 }} />
      )}
      {children}
    </span>
  )
}
